import React, { useRef, useState } from 'react';
import './styles.css';
import {useSelector} from "react-redux";
import {getLanguage} from "../LanguageModal/reducer";
import translations from "../LanguageModal/translations";
import {getTypeExhibition} from "../../views/Home/reducer";
export default function VCard(props) {
    const {
        vcard = '',
    } = props
    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];

    const t = (key) => {
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const [photoSrc, setPhotoSrc] = useState('');
    const cardInfoRef = useRef();
    const nameRef = useRef();
    const orgRef = useRef();
    const titleRef = useRef();
    const telRef = useRef();
    const addressRef = useRef();
    const emailRef = useRef();

    function downloadToFile(content, filename, contentType) {
        const a = document.createElement('a');
        const file = new Blob([content], { type: contentType });

        a.href = URL.createObjectURL(file);
        a.download = filename;
        a.click();

        URL.revokeObjectURL(a.href);
    }

    const makeVCardVersion = () => `VERSION:3.0`;
    const makeVCardInfo = (info) => `N:${info}`;
    const makeVCardName = (name) => `FN:${name}`;
    const makeVCardOrg = (org) => `ORG:${org}`;
    const makeVCardTitle = (title) => `TITLE:${title}`;
    const makeVCardPhoto = (img) => `PHOTO;TYPE=JPEG;ENCODING=b:${img}`;
    const makeVCardTel = (phone) => `TEL;TYPE=WORK,VOICE:${phone}`;
    const makeVCardAdr = (state, country) => `ADR:;;;;${state};;${country}`;
    const makeVCardEmail = (email) => `EMAIL:${email}`;
    const makeVCardTimeStamp = () => `REV:${new Date().toISOString()}`;

    function makeVCard(vcard) {
        if(vcard) {
            downloadToFile(vcard, 'vcard.vcf', 'text/vcard');
        }
    }

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));

    //console.log('vcard', vcard);
    if (!vcard)
        return;

    function parseVCard(vcardText) {
        const lines = vcardText.split(/\r?\n/);
        const result = {
            version: '',
            name: {},
            fullName: '',
            organization: '',
            title: '',
            address: {},
            phones: [],
            emails: []
        };

        for (const line of lines) {
            if (!line.trim()) continue;

            // Обработка многострочных свойств
            if (line.startsWith(' ') || line.startsWith('\t')) {
                // Продолжение предыдущего свойства (не реализовано для простоты)
                continue;
            }

            const [property, ...valueParts] = line.split(':');
            const value = valueParts.join(':').trim();
            const [name, ...params] = property.split(';');

            switch (name.toUpperCase()) {
                case 'BEGIN':
                case 'END':
                    break;

                case 'VERSION':
                    result.version = value;
                    break;

                case 'N':
                    const [lastName, firstName, middleName, prefix, suffix] = value.split(';');
                    result.name = { lastName, firstName, middleName, prefix, suffix };
                    break;

                case 'FN':
                    result.fullName = value;
                    break;

                case 'ORG':
                    result.organization = value;
                    break;

                case 'TITLE':
                    result.title = value;
                    break;

                case 'ADR':
                    const [poBox, extAdr, street, city, region, postalCode, country] = value.split(';');
                    result.address = { poBox, extAdr, street, city, region, postalCode, country };
                    break;

                case 'TEL':
                    const phone = {
                        value: value,
                        types: params.filter(p => !p.startsWith('TYPE=')),
                        isWork: params.some(p => p.includes('WORK')),
                        isCell: params.some(p => p.includes('CELL')),
                        isVoice: params.some(p => p.includes('VOICE'))
                    };
                    result.phones.push(phone);
                    break;

                case 'EMAIL':
                    const email = {
                        value: value,
                        types: params.filter(p => !p.startsWith('TYPE=')),
                        isWork: params.some(p => p.includes('WORK')),
                        isInternet: params.some(p => p.includes('INTERNET'))
                    };
                    result.emails.push(email);
                    break;

                default:
                    // Сохраняем неизвестные свойства
                    if (!result.other) result.other = {};
                    result.other[name] = value;
            }
        }

        return result;
    }

    const contact = parseVCard(vcard.vcard);
    // console.log(contact);

    return (
        <div className='vcard'>
            <div className={`vcard-header ${typeExhibition}`}>
                <p className='vcard-header-text'>{t('contact')}</p>
            </div>
            <div className='vcard-text-container'>
                <p className='vcard-text'>
                    <span style={{fontWeight: 'bold'}}>{t('name')}: </span>
                    {contact?.name?.firstName}
                </p>
                <p className='vcard-text'>
                    <span style={{fontWeight: 'bold'}}>{t('surname')}: </span>
                    {contact?.name?.lastName}
                </p>
                <p className='vcard-text'>
                    <span style={{fontWeight: 'bold'}}>{t('org')}: </span>
                    {contact?.organization}
                </p>
                <p className='vcard-text'>
                    <span style={{fontWeight: 'bold'}}>{t('jobTitle')}: </span>
                    {contact?.title}
                </p>
                <p className='vcard-text'>
                    <span style={{fontWeight: 'bold'}}>{t('phoneNumber')}: </span>
                    {contact?.phones[0]?.value}
                </p>
                <p className='vcard-text'>
                    <span style={{fontWeight: 'bold'}}>{t('mail')}: </span>
                    {contact?.emails[0]?.value}
                </p>
                {contact?.address?.country && <p className='vcard-text'>
                    <span style={{fontWeight: 'bold'}}>{t('country')}: </span>
                    {contact?.address?.country}
                </p>}
                {contact?.address?.region && <p className='vcard-text'>
                    <span style={{fontWeight: 'bold'}}>{t('region')}: </span>
                    {contact?.address?.region}
                </p>}

            </div>
            <button className={`vcard-btn ${typeExhibition}`} onClick={() => makeVCard(vcard.vcard)}>{t('addContact')}</button>
        </div>
    )
}
